import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import Sidebar from "@/components/Sidebar";
import SyncHealthBanner from "@/components/SyncHealthBanner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Particulieren from "@/pages/Particulieren";
import Parkeren from "@/pages/Parkeren";
import StatusView from "@/pages/StatusView";
import BriefVerstuurd from "@/pages/BriefVerstuurd";
import FollowThrough from "@/pages/FollowThrough";
import FollowThroughDetail from "@/pages/FollowThroughDetail";
import Archive from "@/pages/Archive";
import Users from "@/pages/Users";
import Statuses from "@/pages/Statuses";
import Contacts from "@/pages/Contacts";
import Tasks from "@/pages/Tasks";
import Comparison from "@/pages/Comparison";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-[var(--ink-500)]">Laden…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppLayout() {
  return (
    <div className="flex h-screen overflow-hidden" data-testid="app-shell">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col overflow-hidden">
        <SyncHealthBanner />
        <div className="flex-1 min-h-0 overflow-auto flex">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Protected>
                <AppLayout />
              </Protected>
            }
          >
            <Route path="/" element={<div className="flex-1 min-w-0 overflow-auto"><Dashboard /></div>} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/lead/:id" element={<LeadDetail />} />
            <Route path="/particulieren" element={<Particulieren />} />
            <Route path="/parkeren" element={<Parkeren />} />
            <Route path="/zoeken" element={<BriefVerstuurd />} />
            <Route path="/brief-verstuurd" element={<BriefVerstuurd />} />
            <Route path="/shortlist" element={<StatusView targetView="parkeren_shortlist" title="Shortlist"
                                                sub="Leads op de shortlist — zowel makelaars als particulieren." />} />
            <Route path="/getekend" element={<StatusView targetView="parkeren_signed" title="Getekend"
                                               sub="Getekende leads — zowel makelaars als particulieren." />} />
            <Route path="/verloren" element={<StatusView targetView="parkeren_lost" title="Verloren"
                                               sub="Verloren leads — zowel makelaars als particulieren." />} />
            <Route path="/ex-particulier" element={<StatusView targetView="parkeren_ex_particulier" title="Ex-particulier"
                                                     sub="Particuliere verkopers die geswitcht zijn naar een makelaar." />} />
            <Route path="/follow-through" element={<FollowThrough />} />
            <Route path="/follow-through/:id" element={<FollowThroughDetail />} />
            <Route path="/archief" element={<Archive />} />
            <Route path="/users" element={<div className="flex-1 min-w-0 overflow-auto"><Users /></div>} />
            <Route path="/statuses" element={<div className="flex-1 min-w-0 overflow-auto"><Statuses /></div>} />
            <Route path="/contacts" element={<div className="flex-1 min-w-0 overflow-auto"><Contacts /></div>} />
            <Route path="/goals" element={<Comparison />} />
            <Route path="/tasks" element={<div className="flex-1 min-w-0 overflow-auto"><Tasks /></div>} />
            <Route path="/reports" element={<div className="flex-1 min-w-0 overflow-auto"><Reports /></div>} />
            <Route path="/settings" element={<div className="flex-1 min-w-0 overflow-auto"><Settings /></div>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
